let route = {
    path: '/modules/orderstore',
    name: 'order-order',
    component: () => import('@/modules/orderstore/index.vue'),
    children: [
        {
            path: 'order',
            name: 'order-management',
            component: () => import('@/modules/orderstore/order.vue'),
            meta: {
                pageTitle: '国内订单查询',
            }
        },
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const OrderStoreRuter = route;
